import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {IconCancel, IconDelete, IconEdit, IconSave, PrimaryIcon} from '../../common/Button';
import {MessageCell, StyledSmall} from '../../common/StyledComponents';
import ConfirmationDialog from '../../common/modal/ConfirmationDialog';
import {
    addEscalationLevel,
    editEscalationLevel,
    removeEscalationLevel,
    updateEscalationLevel
} from '../../../actions/admin/actionAdminEscalationLevel';

class EscalationLevelRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            valueName: this.props.data.name,
            isOpenRemoveDialog: false
        };
    }

    onClickPencil = e => {
        const {adminEscalationLevel, index, data, domain, updateEscalationLevel, editEscalationLevel} = this.props;
        const {valueName} = this.state;
        e.preventDefault();
        if ((adminEscalationLevel.edit === index) && ((valueName !== data.name))) {
            const item = {
                uuid: data.uuid,
                name: valueName,
            };
            updateEscalationLevel(domain, item);
        } else if (adminEscalationLevel.edit === index) {
            editEscalationLevel(-1);
        } else {
            this.setState({valueName: data.name});
            editEscalationLevel(index);
        }
    };

    onCancel = e => {
        e.preventDefault();
        this.setState({valueName: this.props.data.name});
        this.props.editEscalationLevel(-1);
    };

    onClickDelete = () => {
        const item = {
            uuid: this.props.data.uuid,
        };
        this.props.removeEscalationLevel(this.props.domain, item);
    };

    onChangeHandlerName = e => {
        e.preventDefault();
        this.setState({valueName: e.target.value});
    };

    onChangeHandlerMessage = e => {
        e.preventDefault();
        this.setState({valueMessage: e.target.value});
    };

    showRemoveModal = () => {
        this.setState({
            isOpenRemoveDialog: true
        });
    };

    closeModal = e => {
        e.preventDefault();
        this.setState({
            isOpenRemoveDialog: false
        });
    };

    saveModal = e => {
        e.preventDefault();
        this.setState({
            isOpenRemoveDialog: false
        });
        this.onClickDelete();
    };

    renderName(index) {
        if (this.props.adminEscalationLevel.edit === index) {
            return (
                <StyledSmall
                    className="form-control"
                    value={this.state.valueName}
                    placeholder="Enter your text here..."
                    onChange={this.onChangeHandlerName}/>
            );
        } else {
            return this.props.data.name;
        }
    }

    renderTools(index) {
        let buttons;

        if (this.props.adminEscalationLevel.edit === index) {
            buttons =
                <div className="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                    <div className="btn-group " role="group" aria-label="First group">
                        <PrimaryIcon className="btn btn-sm m-sm-1" onClick={this.onClickPencil}
                                     title="Save" type="button">
                            <IconSave/>
                        </PrimaryIcon>
                    </div>
                    <div className="btn-group " role="group" aria-label="Second group">
                        <PrimaryIcon className="btn btn-sm  m-sm-1" onClick={this.onCancel}
                                     title="Cancel" type="button">
                            <IconCancel/>
                        </PrimaryIcon>
                    </div>
                </div>
        } else {
            buttons =
                <div className="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                    <div className="btn-group " role="group" aria-label="First group">
                        <PrimaryIcon className="btn btn-sm m-sm-1" onClick={this.onClickPencil}
                                     title="Edit" type="button">
                            <IconEdit/>
                        </PrimaryIcon>
                    </div>
                    <div className="btn-group " role="group" aria-label="Second group">
                        <PrimaryIcon className="btn btn-sm m-sm-1" title="Delete" type="button"
                                     onClick={this.showRemoveModal}>
                            <IconDelete/>
                        </PrimaryIcon>
                    </div>
                </div>
        }

        return buttons;
    }

    render() {
        const {index} = this.props;
        return (
            <tr className="d-flex">
                <MessageCell className="col-10">{this.renderName(index)}</MessageCell>
                <td className="col-2">{this.renderTools(index)}</td>
                <ConfirmationDialog show={this.state.isOpenRemoveDialog} closeModal={this.closeModal}
                                    saveModal={this.saveModal} actionIdentifier="remove the escalation level"/>
            </tr>
        );
    }
}

EscalationLevelRow.propTypes = {
    data: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    adminEscalationLevel: state.adminEscalationLevel,
});

export default connect(mapStateToProps, {
    addEscalationLevel,
    editEscalationLevel,
    removeEscalationLevel,
    updateEscalationLevel
})(EscalationLevelRow);
